import Icon from '../icon/Icon'
import {
  FieldContainer,
  FieldLabel,
  TilesGrid,
  Tile,
  TileEmoji,
  TileTitle,
  TileDescription,
  HelperText,
} from './styled'
import { ChoiceTileGroupProps } from './types'

/**
 * Single-select grid of large tiles. Used for higher-stakes choices like
 * "whole property vs unit" where chip-density would underserve the option.
 *
 * @param {ChoiceTileGroupProps<TValue>} props
 * @returns {JSX.Element}
 */
const ChoiceTileGroup = <TValue extends string>({
  label,
  options,
  selectedValue,
  onChange,
  helperText,
}: ChoiceTileGroupProps<TValue>): JSX.Element => {
  return (
    <FieldContainer>
      <FieldLabel>{label}</FieldLabel>
      <TilesGrid>
        {options.map(option => {
          const isSelected = selectedValue === option.value
          return (
            <Tile
              key={option.value}
              type="button"
              isSelected={isSelected}
              onClick={() => onChange(option.value)}
            >
              {option.icon !== undefined ? (
                <TileEmoji aria-hidden="true">
                  <Icon icon={option.icon} />
                </TileEmoji>
              ) : null}
              <TileTitle>{option.title}</TileTitle>
              {option.description !== undefined ? (
                <TileDescription>{option.description}</TileDescription>
              ) : null}
            </Tile>
          )
        })}
      </TilesGrid>
      {helperText !== undefined && helperText !== '' ? (
        <HelperText>{helperText}</HelperText>
      ) : null}
    </FieldContainer>
  )
}

export default ChoiceTileGroup
